import {StockSearchPillCollection} from "@/classes/stock/StockSearchPillCollection";

export default class SkuHistorySearchPillCollection extends StockSearchPillCollection {
    constructor() {
        super();

        this.jobNumber = {
            enabled: true,
            history: []
        };

        this.dateFrom = {
            enabled: true,
            history: []
        };

        this.dateTo = {
            enabled: true,
            history: []
        };

    }

}
